import React, { Component } from "react";
import * as C from "vonnegut.components";
import { observer, inject } from "mobx-react";
import { clone } from "mobx-state-tree";
import * as Icon from "react-feather";
import * as M from "@material-ui/core";
import { createFilter } from "react-search-input";

const UserList = class extends Component {
  state = {
    showAnonymous: false
  };
  cols = [
    { label: "createdOn", key: "createdOn", width: "20%", type: "date" },
    { label: "emailVerified", key: "emailVerified", type: "select" },
    { label: "email", key: "email", width: "40%" },
    { label: "roles", key: "roles", width: "200px", type: "string" },
    { label: "groep", key: "groupNames", width: "30%" },
    {
      type: "action",
      icon: <Icon.Edit2 />,
      className: "bg-transparent",
      onClick: (e, user) => {
        this.props.store.$user.change("selected", clone(this.props.store.$user.list.get(user.uid)));
        this.props.store.$router.push("/user/edit/" + user.uid);
      }
    }
  ];
  render() {
    const { $user } = this.props.store;
    return (
      <div>
        <M.TextField
          placeholder="Zoek op ID, Groep, email, ..."
          fullWidth
          onChange={e => $user.change("filterSearch", e.target.value)}
          name="filter-search"
        />

        <div className="mt-4 mb-4 ">
          <b>
            {
              $user.filteredList.filter(
                user => (!this.state.showAnonymous && user.email) || this.state.showAnonymous
              ).length
            }
          </b>
          &nbsp;gebruikers gevonden
        </div>

        <C.List cols={this.cols} className="zebra" sortKey="createdOn" sortDirection="desc">
          {$user.filteredList
            .filter(createFilter($user.filterSearch, ["name", "email", "_key"]))
            .filter(user => (!this.state.showAnonymous && user.email) || this.state.showAnonymous)
            .map(user => (
              <C.ListRow key={"user" + user.uid} row={user} {...user} />
            ))}
        </C.List>
      </div>
    );
  }
};
export default inject("store")(observer(UserList));
